import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-admin-signs-add',
  templateUrl: './admin-signs-add.component.html'
})
export class AdminSignsAddComponent implements OnInit {
  @Input() formdata;
  @Input() types;
  @Output() doSave = new EventEmitter();
  @Output() doCancel = new EventEmitter();
  form;
 

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      id: [null, ''],
      abbreviation: ['', ''],
      name: ['', ''],
      type: ['', ''],
      sort: ['', '']
    });
  }
  
  setType(evt) {
    this.form.patchValue({ type: evt.value });
  }

  saveSign() {
    this.doSave.emit(this.form.value);
  }

  cancel() {
    this.doCancel.emit();
  }
}
